import { EzhardApp } from '@ezhard/sdk';

export const app = EzhardApp.init({
  endpoint: import.meta.env.VITE_EZHARD_ENGINE_URL || 'https://engine.ezhard.co.il',
  appId: 'ezhaul',
  errorReporting: true,
});

// Export client instances for convenience
export const auth = app.auth;
export const forge = app.forge;
export const vault = app.vault;
export const spark = app.spark;
export const realtime = app.realtime;
